/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Live_PreviewInputs */

const en_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live preview`)
};

const ar_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معاينة مباشرة`)
};

const bn_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লাইভ প্রিভিউ`)
};

const de_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Vorschau`)
};

const es_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa en vivo`)
};

const fr_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu en direct`)
};

const pt_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualização ao vivo`)
};

const zh_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时预览`)
};

const tr_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı önizleme`)
};

const ru_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр в реальном времени`)
};

const pl_svchip_live_preview = /** @type {(inputs: Svchip_Live_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podgląd na żywo`)
};

/**
* | output |
* | --- |
* | "Live preview" |
*
* @param {Svchip_Live_PreviewInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_live_preview = /** @type {((inputs?: Svchip_Live_PreviewInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Live_PreviewInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_live_preview(inputs)
	if (locale === "bn") return bn_svchip_live_preview(inputs)
	if (locale === "de") return de_svchip_live_preview(inputs)
	if (locale === "es") return es_svchip_live_preview(inputs)
	if (locale === "fr") return fr_svchip_live_preview(inputs)
	if (locale === "pt") return pt_svchip_live_preview(inputs)
	if (locale === "zh") return zh_svchip_live_preview(inputs)
	if (locale === "tr") return tr_svchip_live_preview(inputs)
	if (locale === "ru") return ru_svchip_live_preview(inputs)
	if (locale === "pl") return pl_svchip_live_preview(inputs)
	return en_svchip_live_preview(inputs)
});